<template>
  <md-app md-waterfall md-mode="fixed" class="c-share">
    <md-app-toolbar md-elevation="4" class="u-fixed md-dense">
      <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
        <md-icon>menu</md-icon>
      </md-button>
      <topbarmenu :show-links="['overview']"></topbarmenu>
    </md-app-toolbar>
    <md-app-drawer :md-active.sync="menuVisible">
      <drawermenu></drawermenu>
    </md-app-drawer>
    <md-app-content class="">
      <branding class="small"></branding>
      <article class="c-article">
        <h2>Sharing is Caring</h2>
        <p class="u-txt-centered">Recommend this app by logging into your favorite social platform.</p>
      </article>
      <div class="c-share__buttons">
        <md-button
          data-network="facebook"
          data-url="http://therealyouapp.nl/over"
          class="st-custom-button md-raised"
          @click="gTagEvent('share', { method: 'Facebook' })"
          >Facebook</md-button
        >
        <md-button
          data-network="linkedin"
          data-url="http://therealyouapp.nl/over"
          class="st-custom-button md-raised"
          @click="gTagEvent('share', { method: 'LinkedIn' })"
          >LinkedIn</md-button
        >
        <md-button
          data-network="twitter"
          data-url="http://therealyouapp.nl/over"
          class="st-custom-button md-raised"
          @click="gTagEvent('share', { method: 'Twitter' })"
          >Twitter</md-button
        >
        <md-button
          data-network="whatsapp"
          data-url="http://therealyouapp.nl/over"
          class="st-custom-button md-raised"
          @click="gTagEvent('share', { method: 'Whatsapp' })"
          >Whatsapp</md-button
        >
        <md-button
          data-network="email"
          data-url="http://therealyouapp.nl/over"
          class="st-custom-button md-raised"
          @click="gTagEvent('share', { method: 'Email' })"
          >Email</md-button
        >
      </div>
    </md-app-content>
  </md-app>
</template>
<script>
import drawermenu from "./partials/MenuDrawer";
import topbarmenu from "./partials/MenuTopbar";
import branding from "./partials/Branding";
import { shareThis } from "../config";
import { translate, googleTags } from "../mixins";

export default {
  name: "Recommend",
  mixins: [translate, googleTags],
  components: {
    drawermenu,
    topbarmenu,
    branding
  },
  created() {
    shareThis();
  },
  mounted() {
    /* eslint-disable */
    if (window.__sharethis__ && window.__sharethis__.config) {
      window.__sharethis__.init(window.__sharethis__.config);
    }
    this.gTagScreenView("Recommend");
  },
  data() {
    return {
      menuVisible: false,
      userActions: false
    };
  }
};
</script>
